// Always include common JS to page-specific
import '/js/common/index';
import {
    addClickHandlers,
    initProductPhotoVideoGallery,
    addProductReviewsLogic,
    addSocialProofBlock,
    initReviewsBlock,
    initProductInStockInfoBlock,
    initVariations,
    initUnavailableProductLogic,
    initProductPhotosByUsersGallery,
    initDolyamePaymentDetails,
} from './functions';
import { initProductQuestions } from "./product-questions";

$(document).ready(() => {
    addClickHandlers();
    initProductPhotoVideoGallery();
    initProductPhotosByUsersGallery();
    addProductReviewsLogic();
    addSocialProofBlock();
    initReviewsBlock();
    initProductInStockInfoBlock();
    initVariations();
    initUnavailableProductLogic();
    initDolyamePaymentDetails();
    initProductQuestions();
});